<div *ngIf="holding" class="col-12 p-2 py-4">
  <div class="justify-content-start w-12">
    <div class="flex flex-column">
      <h3 class="holding-name title">{{ holding.name }}</h3>
      <div *ngIf="!holding.isEnabled" class="flex flex-row align-content-start py-2">
        <i class="pi pi-exclamation-circle"></i>
        <span class="py-2 disabled-text">This holding record is disabled</span>
      </div>
      <div class="flex holding-static-name">
        HOLDING <span *ngIf="holding.isBigPlayer" class="pl-2"><strong> BIG PLAYER</strong></span>
      </div>
      <div>
        <span><strong>Last Review: </strong></span>
        {{ holding.lastReview | date: 'dd/MM/yyyy' }}
      </div>
    </div>
  </div>
</div>
